
import template from './ko-render-field-text.html';

class TextInputComponentVM
{
	constructor(params)
	{
		this.params = params;
		
		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.multiline = ko.observable(params.multiline || false);
		this.rows = ko.observable(params.rows || 5);
		this.$input = params.$input;

		if (params.type == 'text_readonly')
			this.readonly(true);
		else
			this.readonly(false);
	}
}


export default {
	name: 'ko-render-field-text',
	viewModel: TextInputComponentVM,
	module_type: 'ko',
	template: template
}